<template>
  <section class="daily-publish-quota">
    <div class="daily-publish-quota__heading" :class="{ 'daily-publish-quota__heading--standalone': !showHeading }">
      <h3 v-if="showHeading">每日铺货额度</h3>
      <span class="daily-publish-quota__off">未授权：0个 / 天</span>
    </div>
    <div class="daily-publish-quota__table-wrap">
      <table class="daily-publish-quota__table">
        <thead><tr><th scope="col">店铺状态</th><th scope="col">授权后每日额度</th></tr></thead>
        <tbody>
          <tr v-for="rule in quotaRules" :key="rule.key">
            <td>
              <span>{{ rule.shop }}</span>
              <span class="daily-publish-quota__status" :class="{ 'daily-publish-quota__status--qualified': rule.qualified }">{{ rule.qualified ? '动销达标' : '动销未达标' }}</span>
            </td>
            <td><strong class="daily-publish-quota__amount">{{ rule.amount }}</strong><span class="daily-publish-quota__unit"> 个 / 天</span><small>{{ rule.limit }}</small></td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="daily-publish-quota__fallback">缺少必要额度数据时默认50个；已知低动销额度更低时按更低值执行，最低可为0。</p>
    <p class="daily-publish-quota__fallback">低动销或状态未知店铺已达标、有效动销数≥1且考核可铺数量为0时，每日最多50个，仍受低动销额度限制。</p>
    <details class="daily-publish-quota__details">
      <summary>额度如何计算？</summary>
      <p><strong>低动销额度（Q）</strong>：系统缓存的低动销店铺每日额度。</p>
      <p><strong>考核可铺数量（H）</strong>：根据本系统30天考核窗口内的在架商品数、有效动销商品数及旧快照后的铺货扣减计算。</p>
      <p>低动销未达标取 min(50, Q)，达标取 min(500, Q, H)；正常店铺未达标为300，达标取 min(500, H)。容量不足时可低于50，包括0。</p>
      <p>低动销或状态未知店铺满足上述零容量条件时，改取 min(50, Q)，Q缺失按50、Q为0仍返回0。旧快照扣减后归零也每日兜底，今日已成功及待执行占用照常扣除；正常店铺规则不变。</p>
    </details>
  </section>
</template>

<script>
export default {
  name: 'DailyPublishQuotaNotice',
  props: {
    showHeading: { type: Boolean, default: true }
  },
  data() {
    return {
      quotaRules: [
        { key: 'low-unqualified', shop: '低动销店铺', qualified: false, amount: '最多50', limit: '不超过低动销额度' },
        { key: 'low-qualified', shop: '低动销店铺', qualified: true, amount: '最多500', limit: '不超过低动销额度；零容量兜底见下方说明' },
        { key: 'normal-unqualified', shop: '正常店铺', qualified: false, amount: '300', limit: '' },
        { key: 'normal-qualified', shop: '正常店铺', qualified: true, amount: '最多500', limit: '不超过考核可铺数量' }
      ]
    }
  }
}
</script>

<style scoped>
.daily-publish-quota { color: #303744; font-size: 14px; line-height: 1.6; text-align: left; }
.daily-publish-quota h3, .daily-publish-quota p { margin: 0; }
.daily-publish-quota h3 { font-size: 14px; font-weight: 600; }
.daily-publish-quota__heading { display: flex; justify-content: space-between; align-items: center; gap: 8px; margin-bottom: 10px; }
.daily-publish-quota__off { font-size: 12px; color: #7b8492; padding: 2px 8px; background: #f2f4f7; border-radius: 4px; }
.daily-publish-quota__table-wrap { border: 1px solid #e7ebf1; border-radius: 8px; overflow: hidden; }
.daily-publish-quota__table { width: 100%; border-collapse: collapse; table-layout: fixed; }
.daily-publish-quota__table th { background: #f7f8fa; font-weight: 500; font-size: 12px; color: #7b8492; text-align: left; padding: 9px 14px; }
.daily-publish-quota__table th:first-child { width: 43%; }
.daily-publish-quota__table td { padding: 10px 14px; border-top: 1px solid #edf0f4; vertical-align: middle; }
.daily-publish-quota__table td:first-child > span:first-child { display: inline-block; margin-right: 8px; }
.daily-publish-quota__status { display: inline-block; padding: 1px 6px; font-size: 11px; color: #8b7290; background: #f4f0f5; border-radius: 4px; white-space: nowrap; }
.daily-publish-quota__status--qualified { color: #438566; background: #edf7f1; }
.daily-publish-quota__amount { font-size: 17px; font-weight: 600; color: #303744; }
.daily-publish-quota__unit { font-size: 12px; color: #7b8492; }
.daily-publish-quota__table small { display: block; color: #7b8492; font-size: 12px; line-height: 1.5; }
.daily-publish-quota .daily-publish-quota__fallback { margin-top: 10px; font-size: 12px; color: #7b8492; }
.daily-publish-quota__details { margin-top: 8px; font-size: 12px; color: #7b8492; }
.daily-publish-quota__details summary { color: #596779; cursor: pointer; width: fit-content; }
.daily-publish-quota__details p { margin-top: 6px; }
.daily-publish-quota__heading--standalone { justify-content: flex-end; }
@media (max-width: 520px) {
  .daily-publish-quota__table th, .daily-publish-quota__table td { padding: 9px 10px; }
  .daily-publish-quota__status { margin-top: 3px; }
  .daily-publish-quota__table th:first-child { width: 39%; }
  .daily-publish-quota__amount { font-size: 16px; }
}
</style>
